module.exports = function() {
  return new Worker(__webpack_public_path__ + "0ce54f73d2d0e6a58053.worker.js");
};